<script setup lang="ts">
import { numHelper } from '@/utils/numHelper.ts'
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  return (typeof props.data === 'string' || typeof props.data === 'number') ? props.data : 0
})

const config = computed(()=>{
  return props.cellConfig
})

const color = computed(() => {
  if(config.value?.config?.color) return config.value?.config?.color
  if(value.value < 0) return '#c30000'
  return '#32a800'
})
</script>

<template>
  <div :class="`table-cell justify-end`" :style="`color: ${color}`">
    <span class="value">{{value > 0 || value < 0 ? numHelper(value).format() : '-'}}</span>
    <span v-if="value > 0 || value < 0">đ</span>
  </div>
</template>

<style scoped lang="scss">
.table-cell{
  display: flex;
  gap: 5px;
  .value {
    font-weight: 500;
  }
  .unit {
    font-size: 10px;
  }
}

</style>
